var render = function render(_c,_vm){return _c('div',{staticClass:"home-feature_container"},[_c('h2',{staticClass:"home-feature_container_title"},[_vm._t("title")],2),_c('div',{staticClass:"home-feature_container_content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }